export const VALID_EMAIL_ADDRESS_REGEX =
  /^[a-z\d!#$%&'*+/=?^_‘{|}~-]+(?:\.[a-z\d!#$%&'*+/=?^_‘{|}~-]+)*@(?:[a-z\d](?:[a-z\d-]*[a-z\d])?\.)+[a-z\d](?:[a-z\d-]*[a-z\d])?$/i;
export const VALID_POSTCODE_REGEX =
  /^([g][i][r] 0[a]{2})|((([a-z]\d{1,2})|(([a-z][a-hj-y]\d{1,2})|(([a-z]\d[a-z])|([a-z][a-hj-y]\d[a-z]?))))\s?\d[a-z]{2})$/i;
export const VALID_PHONE_NUMBER_REGEX = /^\d{11}$/;
export const VALID_DATE_REGEX =
  /^((([0-2])?(\d))|(([0-3])([0-1])))\/(((0)?([1-9]))|((1)([0-2]{1,2})))\/(\d){4}$/;
